export const SET_COURSE_DECLARATION_INFO = 'SET_COURSE_DECLARATION_INFO';
export const RESET_COURSE_DECLARATION_INFO = 'RESET_COURSE_DECLARATION_INFO';
export const SET_END_DECLARE_COURSE = 'SET_END_DECLARE_COURSE';
export const RESET_END_DECLARE_COURSE = 'SET_END_DECLARE_COURSE';


const initialState = null


export function declarationCourseReducers(state = initialState, action: any) {
  switch (action.type) {
    case SET_COURSE_DECLARATION_INFO:
      return action.payload;
    case RESET_COURSE_DECLARATION_INFO:
      return action.payload;
    default:
      return state
  }
}
export function endDeclareCourseReducers(state = initialState, action: any) {
  switch (action.type) {
    case SET_END_DECLARE_COURSE:
      return action.payload;
    case RESET_END_DECLARE_COURSE:
      return action.payload;
    default:
      return state
  }
}